import * as React from 'react';
import styled, {
  createGlobalStyle,
} from 'styled-components';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';

const ModalBlockError = ({ children }: Props) => (
  <ModalContainer>
    <GlobalStyles />
    <ModalContent>
      <ErrorIcon />
      <Content>{children}</Content>
    </ModalContent>
  </ModalContainer>
);

const GlobalStyles = createGlobalStyle`
  body {
    max-height: 100vh;
    overflow: hidden;
  }
`;

const ModalContainer = styled.div`
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  padding: 40px 20px;
  overflow: auto;
  display: flex;
  background-color: rgba(19, 23, 32, 0.82);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
`;

const ModalContent = styled.div.attrs({
  className: 'modal-window__modal-content',
})`
  position: relative;
  margin: auto;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 680px;
  justify-content: center;
  padding: var(--space-12) var(--space-12);
  border-radius: var(--radius-lg);
  border: 1px solid var(--neutral-200);
  background-color: var(--neutral-0);
  box-shadow: var(--shadow-lg);
`;

const ErrorIcon = styled(WarningRoundedIcon)`
  color: var(--danger-500);
  font-size: 96px;
  margin: 0 auto var(--space-6) auto;
`;

const Content = styled.div`
  background-color: var(--neutral-50);
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  border: 1px solid var(--neutral-200);
  border-radius: var(--radius-md);
  padding: var(--space-6);
  font-size: var(--fs-lg);
  color: var(--neutral-800);
  line-height: var(--lh-normal);
`;

interface Props {
  children: React.ReactNode | React.ReactNodeArray;
}

export default ModalBlockError;
